export default __webpack_public_path__ + "static/media/cat-001.713d51e1.svg";